module.exports = __webpack_public_path__ + "assets/media/msteams-icon.cc770d27.svg";